import store from "../store/store"

export default {
    calculateFlows(measurements=[], equations){
        // console.log('calculateFlows',measurements, equations);
        let FLOW
        const validDate = (equation) =>{
            let now = new Date()
            let start =_.get(equation.options, 'constraints.period.start')
            if(start && new Date(start).getTime() <= now.getTime()){
                let end =_.get(equation.options, 'constraints.period.end')
                //data inicio valida
                if(!end || new Date(end).getTime() >= now.getTime()){
                    return true
                }
            }
            return false
        }
        const validValue = (equation, value) =>{
            //esse valor esta chegando em centimentros
            value = value / 100 //transformando para metros
            let start = _.get(equation.options, 'constraints.range.start')
            let end = _.get(equation.options, 'constraints.range.end')
            let value_type = _.get(equation.options, 'constraints.range.value_type') || "cm"
            let offset = _.get(equation.options, 'constraints.offset') || "cm"

            if(start >= 0 && end >0){
                if(offset){
                    value = (offset.value_type && offset.value_type === 'cm') ? value + parseFloat(offset.value) / 100 : value + parseFloat(offset.value)
                }
                if(parseFloat(start) <= (value_type == 'cm' ? value * 100 : value) && parseFloat(end) >= (value == 'cm' ? value * 100: value)){
                    return value
                }
            }
            return false
        }
        const getValidEquation = (measurement) =>{
            let EQUATION
            equations.forEach(equation=>{
                if(validDate(equation)){
                    //data valida
                    let value = validValue(equation, measurement.value)
                    if(value > 0){
                        EQUATION = equation
                        //valor valido
                    } else {
                        console.log('valor invalido');    
                    }                   
                } else {
                    console.log('data invalida');
                }
            })
            return EQUATION
        }
        measurements.forEach(measurement=>{
            let equation = getValidEquation(measurement)
            if(equation){
                let format = equation.equation_type.options.format
                let offset = _.get(equation.options, 'constraints.offset') || "cm"
                let range = _.get(equation.options, 'constraints.range') || {value_type: 'm'}
                let value = range.value_type === 'cm' ? measurement.value : measurement.value / 100
            
                Object.keys(equation.values).forEach(key =>{
                    format = format.replaceAll(key, equation.values[key])    
                })

                if(offset){
                    value = (offset.value_type && offset.value_type === 'cm') ? value + parseFloat(offset.value) / 100 : value + parseFloat(offset.value)
                }

                format = format.replaceAll('x', value)
                
                FLOW = eval(format)

                measurement.read_value = FLOW
            }
            
        })
        return measurements
        
    },
    calculateAcum(measurements){
        let current = 0
        measurements.forEach(measurement=>{
            current = parseFloat(measurement.value) + current
            measurement.read_value = current
        })
        return measurements
    }
}